import { Fragment } from 'react';
import { Trans } from 'react-i18next';

type GoalPriorityInfoTextProps = {
    values?: Record<string, unknown>;
    renameWishToAspire?: boolean;
};

type GoalPriorityValueKey = 'need' | 'want' | 'wish' | 'dream' | 'desire';

const PRIORITY_ORDER: GoalPriorityValueKey[] = ['need', 'want', 'wish', 'dream', 'desire'];

const isValidValue = (value: unknown): value is number => typeof value === 'number' && !Number.isNaN(value);

export const GoalPriorityInfoText = ({ values, renameWishToAspire = false }: GoalPriorityInfoTextProps) => {
    const getValue = (key: GoalPriorityValueKey) => {
        const capitalizedKey = `${key.charAt(0).toUpperCase()}${key.slice(1)}`;
        return values?.[key] ?? values?.[capitalizedKey];
    };

    const visiblePriorityKeys = PRIORITY_ORDER.filter((key) => isValidValue(getValue(key)));

    return (
        <>
            {visiblePriorityKeys.map((key, index) => {
                if (key === 'wish' && renameWishToAspire) {
                    return (
                        <Fragment key={key}>
                            <Trans
                                i18nKey={`GOAL_PRIORITY_INFO_TEXT_ASPIRE`}
                                values={{ [key]: getValue(key) }}
                                components={{ strong: <strong /> }}
                            />
                            {index < visiblePriorityKeys.length - 1 && <br />}
                        </Fragment>
                    );
                }

                return (
                    <Fragment key={key}>
                        <Trans
                            i18nKey={`GOAL_PRIORITY_INFO_TEXT_${key.toUpperCase()}`}
                            values={{ [key]: getValue(key) }}
                            components={{ strong: <strong /> }}
                        />
                        {index < visiblePriorityKeys.length - 1 && <br />}
                    </Fragment>
                );
            })}
            {visiblePriorityKeys.length > 0 && <br />}
            <Trans i18nKey="GOAL_PRIORITY_INFO_TEXT_MULTI_GOAL_NOTE" />
        </>
    );
};
